// Feature flags for the Rate the Ranch redesign.
// The design prototype exposed these as tweakable props; here they are
// implemented as config constants (all default true / 'photo').
const config = {
  // 'photo' = bottle photo cutout, 'bottle' = simple SVG silhouette, 'star' = classic gold stars
  ratingIcon: "photo",
  // Show the live rating reaction word under the icons
  ratingWord: true,
  // Springy scale on hover/press of rating icons
  bounceOnSelect: true,
  // Confetti burst + toast on successful submit
  confetti: true,
  // Show the Google Maps section
  showMap: true,
  // Hero intro "pop" animation on load
  logoIntro: true,
};

export default config;
